import { styled, selectTheme, Inlinelink } from '@creditas-ui/react';

const Link = styled(Inlinelink)`
  text-decoration: none;
  font-family: ${selectTheme('fontFamily.base')};
  font-size: ${selectTheme('fontSizes.sm')};
  color: ${selectTheme('colors.primary.60')};
`;

export { Link };
